import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './baseQuery';

const tagTypes = [
  'Appointments',
  'Clients',
  'Conversations',
  'Drafts',
  'Master',
  'Messages',
  'Onboard',
  'OnboardProgress',
  'Schedule',
  'ScheduleAroundToday',
  'Services',
  'Settings',
  'SettingsBooking',
  'SettingsCalendar',
  'SettingsCommunicationChannels',
  'SettingsContacts',
  'SettingsProfile',
  'SettingsSchedule',
  'SettingsWorkplaces',
  'Slots',
  'Subscription',
  'UpcomingAll',
  'UpcomingAppointment',
  'UpcomingDraft',
  'WeeklyScheduleTemplate',
] as const;

export const api = createApi({
  baseQuery: axiosBaseQuery({}),
  endpoints: () => ({}),
  keepUnusedDataFor: 60 * 15, // 15 minutes in seconds
  reducerPath: 'api',
  tagTypes,
});
